import { useMemo } from 'react'
import { I18nextProvider } from 'react-i18next'
import ApiClient from './ApiClient'
import { AppProvider } from './contexts/AppContext'
import { initI18n } from './i18n/config'
import AppRouter from './router/AppRouter'
import './styles/index.css'
import { CuratedPhotoForPhotoProducts } from './types'

export interface ApiConfig {
  apiBasePath: string
  sessionToken?: string
  extraLogParams: Record<string, unknown>
}

export interface AppProps {
  locale?: string
  basePath?: string
  premiumDeepLinkUrl?: string
  isPremiumUser?: boolean | null
  isPostPurchaseModal?: boolean
  userPhotos?: CuratedPhotoForPhotoProducts[]
  apiConfig?: ApiConfig
  isAmazonSaleActive?: boolean
}

const App = (props: AppProps) => {
  const i18nInstance = useMemo(() => initI18n(props.locale), [props.locale])

  const api = useMemo(() => {
    if (props.apiConfig) {
      return new ApiClient(props.apiConfig)
    }
    return null
  }, [props.apiConfig])

  return (
    <AppProvider value={{ ...props, api }}>
      <I18nextProvider i18n={i18nInstance}>
        <AppRouter basePath={props.basePath} />
      </I18nextProvider>
    </AppProvider>
  )
}

export default App
